// This file holds all possible default configuration
const homeDomain = 'customer.xfinity.com';
const mobileDomain = 'xfinity.com/mobile';
const paymentDomain = 'payments.xfinity.com';

const paymentPlanRoute = '/xfinity-assistance-plan';

const CONFIG = {
  paymentPlanRoute, // avoid circle dep
  // Payment setup page
  paymentSetup: {
    // Where to go if no continueUrl specified (from consent flow)
    defaultContinue: `https://${homeDomain}/`,
    // Affiliate IDs that are valid for payment setup flow
    validAffiliates: ['ACSR'],
    // Delay before redirection (for QA only; should always be 0 in production)
    redirectDelay: 0,
  },
  // The name of the cookie that the linked account index is stored on.
  accountSwitcherCookieName: 'maw_accountIndex',
  // TODO: remove the legacy cookie during cleanup after account selection rollout
  legacyAccountSwitcherCookieName: 'maw_cspTokenIndex',
  accountSwitcherCookieDomain: '.xfinity.com',
  accountPopupCookie: 'maw_accountPopupCookie',
  homeDomain,
  mobileDomain,
  billServicesUrl: `https://${homeDomain}/billing/services`,
  billingMobileUrl: `https://${homeDomain}/billing/mobile`,
  billingMobileTransactionsUrl: `https://${homeDomain}/billing/mobile/transactions`,
  makePaymentUrl: `https://${paymentDomain}/new`,
  billingUrl: `https://${homeDomain}/billing`,
  paymentPlanUrl: `https://${paymentDomain}${paymentPlanRoute}`,
  cwaRoot: 'https://static.cimcontent.net/common-web-assets/',
  featureFlagEndpoint: 'https://sdx.xfinity.com/cms/data/myAccount/web/featureFlags.json',
  shelbyCMSUrl: 'https://sdx.xfinity.com/cms/data/',
  maxOptionsPaymentPlan: 1, // todo move to CMS
  xaUrl: 'https://www.xfinity.com/xfinityassistant',
  oauthUrl: 'https://oauth.xfinity.com',
  collectionsBack: 'https://www.xfinity.com/buy/plan/xap',
  coreCpcEnvironment: 'preproduction',
  coreCpcUrl: 'https://common-payment.preprod.xfinity.com/',
  xmCpcEnvironment: 'integration',
  xmCpcUrl: 'https://common-payment.int.xfinity.com/',
  nowMobileUrl: `https://${mobileDomain}/my-account/now/activity`,
  xmMyAccountUrl: `https://${mobileDomain}/my-account`,
  devicesMobileUrl: `https://${mobileDomain}/my-account/devices`,
  coreCustomerHomepage: 'https://www.xfinity.com/auth',
  mobileHomepage: 'https://www.xfinity.com/mobile',
  xfinityNewPaymentTermsUrl: 'https://www.xfinity.com/Corporate/Customers/Policies/onetimepayment',
  xfinityMobileNewPaymentTermsUrl: 'https://www.xfinity.com/terms',
  cimaClientId: 'my-account-web-development',
  cottonClientId: 'dss-mw-pci-dev',
  firebaseEnabled: false,
  firebaseConfig: {
    apiKey: 'AIzaSyASbdXi4FOQ6G5jlfsWOCsqqpruV3mk4E4',
    authDomain: 'dss-maw-pci-dev-974534.firebaseapp.com',
    projectId: 'dss-maw-pci-dev-974534',
    storageBucket: 'dss-maw-pci-dev-974534.firebasestorage.app',
    messagingSenderId: '583702985741',
    appId: '1:583702985741:web:8e44fb9a21658c9707a944',
    measurementId: 'G-VZNHBGVCKT',
  },
};

export default CONFIG;
